import { render, staticRenderFns } from "./IntervoiceVoiceVapi.vue?vue&type=template&id=6fa56e45"
import script from "./IntervoiceVoiceVapi.vue?vue&type=script&lang=js"
export * from "./IntervoiceVoiceVapi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports